import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Grid,
  InputAdornment,
  Paper,
  TextField,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Copyright from '../../components/Copyright/Copyright';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { faEye, faEyeSlash } from '@fortawesome/pro-duotone-svg-icons';
import styled from '@emotion/styled';
import FadeIn from 'react-fade-in';
import Axios from 'axios';
import Loading from '../../components/Loading/Loading';
import { useCookies } from 'react-cookie';
import DarkModeToggle from 'react-dark-mode-toggle';
import ImgMock3 from '../../assets/mocks/img/Reward-coin.png';
import { useSnackbar } from 'notistack';
import { LogToBackend } from '../../configs/helpers/LogToBackend';
import { Encrypt } from '../../configs/helpers/Encrypt';
import { Controller, useForm } from 'react-hook-form';

const LogoIMG = styled.img`
  width: 22rem;
  display: block;
`;

const useStyles = makeStyles((theme) => ({
  BoxLight: {
    background: 'linear-gradient(to bottom, #ec008c, #fc6767)',
  },
  BoxDark: {
    background: 'linear-gradient(to bottom, #ff0084, #33001b)',
  },
  paper: {
    borderRadius: '10px',
    lineHeight: '5',
  },
  grid: {
    borderRadius: '10px',
  },
  gridRight: {
    borderBottomRightRadius: '10px',
    borderTopRightRadius: '10px',
    padding: '0 0 3rem 0',
  },
  gridLeftDark: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    borderBottomLeftRadius: '10px',
    borderTopLeftRadius: '10px',
  },
  gridLeft: {
    backgroundColor: '#ffe9ed',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    borderBottomLeftRadius: '10px',
    borderTopLeftRadius: '10px',
  },
  input: {
    width: '50%',
  },
  buttonSubmit: {
    width: '35%',
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  },
  buttonSubmitDark: {
    width: '35%',
    background: 'linear-gradient(45deg, #33001b 2%, #ff0084 90%)',
  },
}));

const LoginUsername = ({ onToggleDark, ...props }) => {
  const PhonePolicy = /^[0-9]+$/;
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const [pwsType, setPwsType] = useState('password');
  const { handleSubmit, register, errors, control } = useForm();
  const [resp, setResp] = useState({
    loading: false,
    // data: null,
    // error: null,
  });
  const [tokenCookie, setTokenCookie] = useCookies(['Token']);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onSubmit = async (values) => {
    setResp({ loading: true });
    try {
      await onLogin(values);
      history.push('/private/main');
    } catch (e) {
      LogToBackend(e);
      if (e.response) {
        const response = e.response.data;
        enqueueSnackbar(response.errorAppMessageTh, {
          variant: 'error',
        });
      } else console.error('site error');
    } finally {
      setResp({ loading: false });
    }
  };
  const onLogin = async (values) => {
    const key = process.env.REACT_APP_SECRET_KEY_SERVICE;
    const pwdEncrypt = await Encrypt(values.password, key);
    const userTrims = values.userName.trim();
    let payLoad;
    if (PhonePolicy.test(userTrims)) {
      payLoad = {
        employeeId: userTrims,
        username: null,
        password: pwdEncrypt,
      };
    } else {
      payLoad = {
        employeeId: null,
        username: userTrims,
        password: pwdEncrypt,
      };
    }
    return new Promise((resolve, reject) => {
      Axios.post('/GSB/dashboard/user/LoginAdmin', payLoad)
        .then((response) => {
          let Data = response.data;
          if (Data.tokenResult !== null) {
            sessionStorage.setItem('token', Data.tokenResult);
            let token = sessionStorage.getItem('token');
            Axios.defaults.headers.common = {
              Authorization: `Bearer ${token}`,
            };
            sessionStorage.setItem('login', true);
          } else {
            enqueueSnackbar('ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบ', {
              variant: 'warning',
            });
          }
          resolve(Data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignContent="center"
      alignItems="center"
      height="100vh"
      textAlign="center"
      className={
        theme.palette.type === 'light' ? classes.BoxLight : classes.BoxDark
      }
    >
      {resp.loading ? (
        <Loading />
      ) : (
        <React.Fragment>
          <Container maxWidth="md" fixed>
            <Paper elevation={0} className={classes.paper}>
              <Grid container className={classes.grid}>
                <Grid
                  item
                  xs={6}
                  className={
                    theme.palette.type === 'light'
                      ? classes.gridLeft
                      : classes.gridLeftDark
                  }
                >
                  <div>
                    <LogoIMG src={ImgMock3} alt="" />
                  </div>
                </Grid>
                <Grid item xs={6} className={classes.gridRight}>
                  <Box
                    display="flex"
                    justifyContent="flex-end"
                    padding="1.5rem 1.5rem"
                  >
                    <DarkModeToggle
                      onChange={onToggleDark}
                      checked={theme.palette.type !== 'light'}
                      size={50}
                    />
                  </Box>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <FadeIn>
                      <div>
                        <div>
                          <Controller
                            rules={{ required: true }}
                            as={
                              <TextField
                                error={errors.userName}
                                helperText={
                                  errors.userName && 'กรุณาระบุ Username'
                                }
                                className={classes.input}
                                label="Username"
                                variant="outlined"
                                type="text"
                                name="employeeId"
                                autoComplete="username"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <FontAwesomeIcon icon={faUser} />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            }
                            name="userName"
                            control={control}
                          />
                        </div>
                        <div>
                          <Controller
                            rules={{ required: true }}
                            as={
                              <TextField
                                error={errors.password}
                                helperText={
                                  errors.password && 'กรุณาระบุ password'
                                }
                                className={classes.input}
                                label="Password"
                                variant="outlined"
                                type={pwsType}
                                name="password"
                                autoComplete="current-password"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <FontAwesomeIcon
                                        icon={
                                          pwsType === 'password'
                                            ? faEye
                                            : faEyeSlash
                                        }
                                        onClick={() =>
                                          pwsType === 'password'
                                            ? setPwsType('text')
                                            : setPwsType('password')
                                        }
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            }
                            name="password"
                            control={control}
                          />
                        </div>
                      </div>
                      <div>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          size="large"
                          className={classes.buttonSubmit}
                        >
                          Login
                        </Button>
                      </div>
                    </FadeIn>
                  </form>
                </Grid>
              </Grid>
            </Paper>
          </Container>
          <Copyright white size={'1.3rem'} />
        </React.Fragment>
      )}
    </Box>
  );
};
export default LoginUsername;
